import { render, staticRenderFns } from "./HeardPcBackground.vue?vue&type=template&id=51bcfc5f&scoped=true&"
import script from "./HeardPcBackground.vue?vue&type=script&lang=js&"
export * from "./HeardPcBackground.vue?vue&type=script&lang=js&"
import style0 from "./HeardPcBackground.vue?vue&type=style&index=0&id=51bcfc5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bcfc5f",
  null
  
)

export default component.exports